export const API_URL_PROD =
  "https://4npxupwcyh.execute-api.us-west-2.amazonaws.com/prod"
